import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/data";

export const BeforeAfter = () => {
  const [idx, setIdx] = useState(0);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);
  const wrap = useRef(null);
  const pair = GALLERY[idx];

  const move = (clientX) => {
    if (!wrap.current) return;
    const rect = wrap.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(2, Math.min(98, p)));
  };

  return (
    <section id="realisations" data-testid="before-after-gallery" className="relative bg-[var(--bg-2)] py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[var(--blue)]">
              [ Avant / Après ]
            </span>
            <h2 className="mt-4 font-display font-bold uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none">
              Le résultat
              <br />
              parle de lui-même
            </h2>
          </div>
          <div className="flex gap-2">
            {GALLERY.map((g, i) => (
              <button
                key={g.label}
                data-testid={`gallery-tab-${g.label.toLowerCase()}`}
                onClick={() => {
                  setIdx(i);
                  setPos(50);
                }}
                className={`font-mono2 text-[11px] uppercase tracking-[0.18em] px-4 py-2.5 rounded-sm border transition-colors duration-300 ${
                  idx === i
                    ? "bg-white text-black border-white"
                    : "text-[var(--txt-1)] border-white/15 hover:border-white/40"
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>
        </div>

        <motion.div
          key={idx}
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          ref={wrap}
          data-testid="before-after-slider"
          className="relative aspect-[16/10] sm:aspect-[16/9] w-full select-none overflow-hidden rounded-md border border-white/10 cursor-ew-resize"
          onMouseMove={(e) => dragging.current && move(e.clientX)}
          onMouseDown={(e) => {
            dragging.current = true;
            move(e.clientX);
          }}
          onMouseUp={() => (dragging.current = false)}
          onMouseLeave={() => (dragging.current = false)}
          onTouchMove={(e) => move(e.touches[0].clientX)}
        >
          <img src={pair.after} alt="Après lavage" className="absolute inset-0 h-full w-full object-cover pointer-events-none" />
          <span className="absolute top-4 right-4 z-20 bg-[var(--blue)] text-white font-mono2 text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5 rounded-sm">
            Après
          </span>

          <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
            <img src={pair.before} alt="Avant lavage" className="absolute inset-0 h-full w-full object-cover pointer-events-none" />
            <span className="absolute top-4 left-4 bg-black/70 text-white font-mono2 text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5 rounded-sm">
              Avant
            </span>
          </div>

          <div className="absolute top-0 bottom-0 z-10 w-[2px] bg-white" style={{ left: `${pos}%` }}>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white flex items-center justify-center shadow-lg">
              <span className="text-black font-mono2 text-xs font-bold">↔</span>
            </div>
          </div>
        </motion.div>
        <p className="mt-4 font-mono2 text-[11px] uppercase tracking-[0.2em] text-[var(--txt-2)]">
          Glissez le curseur pour comparer
        </p>
      </div>
    </section>
  );
};
